module.exports = __webpack_public_path__ + "static/img/zaixianzixun.b6b7efcc.png";